import { useEffect, useState } from "react";
import {
  PARTY_TYPES,
  PICKLIST_GROUP_NAME,
  STAKEHOLDER_TYPE,
  WEB_ROLE,
} from "../../../../common/Constant";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import moment from "moment";
import { fetchPickListByGroupName } from "../../../../services/CaseInformationApi";
import {
  addStakeholderContact,
  GetStakeholderContactInfo,
  getuserName,
  getUserRoleForPMC,
  updateStakeholderContact,
} from "../../../../services/StakeholderApi";
import { validateStakeholderContactInfo } from "../../../Master/Stakeholders/components/stakeholderValidation";
import AccordionComponent from "../../../../common/Accordion";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tab,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import TextInput from "../../../../common/TextInput";
import FormattedPhoneInput from "../../../../common/FormattedPhoneInput";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import DataTable from "../../../../common/DataTable";
import {
  CONTACT_LOG_HEADERS,
  STAKEHOLDERS_CONTACT,
  STAKEHOLDERS_QME_CONTACT,
} from "../../../Master/Stakeholders/actions/Constant";
import Snackbar from "../../../../common/Snackbar";
import AddNewContactLocation from "./AddNewContactLocation";
import TagComponent from "../../../../common/TagComponent";
import { fetcheaderinfo } from "../../../../services/UserRegistrationApi";
import { addPartyNotificationConfiguration } from "../../../../services/NotificationConfigurationAPI";

interface ContactProps {
  partyID: number;
  partyType: any;
  partyTypeID: any;
  setHasContactData: any;
  StakeholderLabel: any;
  onBack: () => void;
}

const AddNewPartyContact: React.FC<ContactProps> = ({
  partyID,
  partyType,
  partyTypeID,
  setHasContactData,
  StakeholderLabel,
  onBack,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [salutationOptions, setSalutationOptions] = useState<any[]>([]);
  const [stakeholderContactID, setStakeholderContactID] = useState<any>("");
  const [salutationTypeId, setSalutationTypeId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState<string[]>([]);
  const [phoneNumber, setPhoneNumber] = useState<string[]>([]);
  const [faxNumber, setFaxNumber] = useState<string[]>([]);
  const [contactUserId, setContactUserId] = useState("");
  const [comment, setComment] = useState("");
  const [isActive, setIsActive] = useState<boolean>(true);
  const [isAllowScheduling, setIsAllowScheduling] = useState<boolean>(false);

  const [specalization, setSpecalization] = useState("");
  const [experience, setExperience] = useState("");

  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [contactData, setContactData] = useState<any[]>([]); // <-- Add state for contact data
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [selectedContact, setSelectedContact] = useState<any>(null);
  const [showPreviousContacts, setShowPreviousContacts] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [contactDetails, setContactDetails] = useState<any[]>([]);
  const [contactName, setContactName] = useState("");
  const [activeTab, setActiveTab] = useState("contact");
  const [showTooltip, setShowTooltip] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [isAlreadyUser, setIsAlreadyUser] = useState(true);
  const [userRoleOption, setUserRoleOption] = useState<any[]>([]);
  const [userRole, setUserRole] = useState<string | number | null>(null);

  const [stakeholderContactDetailKey, setstakeholderContactDetailKey] =
    useState<string | null>("0");

  const [stakeholderContactDetailFormKey, setstakeholderContactDetailFormKey] =
    useState<string | null>("0");

  const params = {
    salutation: {
      groupName: PICKLIST_GROUP_NAME.Salutation_Type,
      triggerById: loggedInUserid,
    },
  };
  const [fullName, setFullName] = useState("");
  // Import moment

  const handlePDFClick = () => {
    if (selectedContact) {
      // Extract the four fields from the selectedContact
      setShowTooltip(false);
      const { createdbyname, createddate, modifiedbyname, modifieddate } =
        selectedContact;

      // Format the date using moment.js
      const formattedCreatedDate =
        moment(createddate).format("MM/DD/YYYY HH:mm");
      const formattedModifiedDate =
        moment(modifieddate).format("MM/DD/YYYY HH:mm");

      // Set the values in the state
      setContactDetails([
        {
          createdbyname,
          createddate: formattedCreatedDate, // Use formatted date
          modifiedbyname,
          modifieddate: formattedModifiedDate, // Use formatted date
        },
      ]);

      // Show the drawer
      setShowDrawer(true);
    }
  };
  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };

  function formatUserName(name: string): string {
    return (
      name
        .replace(/\(U\)/g, "(") // Replace (U) with just (
        .replace(/\s*\(E\)\s*/g, "") // Remove (E)
        .replace(/;/g, "-") // Replace ; with -
        .trim() + " )"
    ); // Ensure proper closing bracket
  }

  const getUserRole = async () => {
    try {
      const userRoleData = await getUserRoleForPMC();

      // Define the structure for each role item
      type RoleItem = { value: number; label: string };

      const allRoles: RoleItem[] = userRoleData.map(
        (item: { webRoleId: number; webRoleName: string }): RoleItem => ({
          value: item.webRoleId,
          label: item.webRoleName,
        })
      );

      const allowedRoles: string[] = [
        WEB_ROLE.Case_Manager,
        WEB_ROLE.QME_DoctorPMC,
        WEB_ROLE.Transcriber,
        WEB_ROLE.Historian,
        WEB_ROLE.Billing_Specialist,
        WEB_ROLE.Editor,
        WEB_ROLE.Scheduler,
        WEB_ROLE.Medical_Assistant,
        WEB_ROLE.IndependentQMEDoctor,
        WEB_ROLE.Record_Reviewer,
        WEB_ROLE.Claims_Administrator,
        WEB_ROLE.Supervisor,
        WEB_ROLE.Practice_Manager,
      ];

      const filteredRoles: RoleItem[] = allRoles.filter((role: RoleItem) =>
        allowedRoles.includes(role.label)
      );

      setUserRoleOption(filteredRoles);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getUserRole();
  }, [StakeholderLabel]);

  const selectedUserRoleLabel = userRoleOption.find(
    (role) => role.value === userRole
  )?.label;

  const fetchData = async () => {
    try {
      const salutationData = await fetchPickListByGroupName(params.salutation);
      setSalutationOptions(salutationData || []);

      const data = await GetStakeholderContactInfo(partyID);
      const formattedData = (data || []).map((item: any) => ({
        ...item,
        isAllowScheduling: item.isAllowScheduling == 1 ? "Yes" : "No",
      }));

      setContactData(formattedData || []); // <-- Update contactData state
      setHasContactData((data || []).length > 0); // Report to parent
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchContactUserData = async (isFreshFetch = false) => {
    const userNameData = await getuserName(partyTypeID, userRole);

    let transformedOptionsuser = userNameData.map(
      (item: { userid: number; userfullname: string }) => ({
        value: item.userid,
        label: formatUserName(item.userfullname),
      })
    );

    // If it's a fresh fetch, do not include any previously edited names
    if (!isFreshFetch && selectedContact?.contactuserid) {
      // const isUserAlreadyInList = transformedOptionsuser.some(
      //   (option) => option.value === selectedContact.contactuserid
      // );

      const isUserAlreadyInList = transformedOptionsuser.some(
        (option: { value: number; label: string }) =>
          option.value === selectedContact.contactuserid
      );

      if (!isUserAlreadyInList) {
        transformedOptionsuser.push({
          value: selectedContact.contactuserid,
          label: formatUserName(selectedContact.contactusernameEdit),
        });
      }
    }

    setUserOptions(transformedOptionsuser);
  };

  useEffect(() => {
    fetchData();
    fetchContactUserData();
  }, []);

  useEffect(() => {
    if (selectedContact) {
      fetchContactUserData();
    }
  }, [selectedContact]);

  const getUserDataFromCredential = async () => {
    try {
      const userCredentialData = await fetcheaderinfo(contactUserId);
      if (userCredentialData) {
        setSalutationTypeId(userCredentialData?.salutationtypeid);
        setFirstName(userCredentialData?.firstname);
        setMiddleName(userCredentialData?.middlename);
        setLastName(userCredentialData?.lastname);
        setEmailId(
          userCredentialData?.emailid
            ? userCredentialData?.emailid
                .split(",")
                .map((num: string) => num.trim())
            : []
        );
        setPhoneNumber(
          userCredentialData?.phonenumber
            ? userCredentialData?.phonenumber
                .split(",")
                .map((num: string) => num.trim())
            : []
        );
        setFaxNumber(
          userCredentialData?.faxnumber
            ? userCredentialData?.faxnumber
                .split(",")
                .map((num: string) => num.trim())
            : []
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getUserDataFromCredential();
  }, [contactUserId]);

  useEffect(() => {
    if (userRole) {
      fetchContactUserData();
    }
  }, [userRole]);

  useEffect(() => {
    if (selectedContact) {
      fetchContactUserData();
    }
  }, [selectedContact]);

  const handleAddContact = () => {
    // Reset all states
    setUserRole("");
    setStakeholderContactID("");
    setContactName("");
    setSalutationTypeId("");
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setExperience("");
    setSpecalization("");
    setEmailId([]);
    setPhoneNumber([]);
    setFaxNumber([]);
    setContactUserId("");
    setComment("");
    setIsActive(true);
    setIsAllowScheduling(false);
    setShowForm(true);
    setSelectedContact(null); // Reset selected contact when adding a new one

    // Clear user options and fetch fresh data
    setUserOptions([]);
    fetchData(); // Pass a flag to indicate it's a fresh fetch
    fetchContactUserData(true);
    setstakeholderContactDetailKey(null);
    setstakeholderContactDetailKey("0");
    setcommunicationDetailSubKey("0");
    setCredentialDetailSubKey("0");
  };

  // Close the form without saving
  const handleCancel = () => {
    setShowModal(true); // Show confirmation modal
  };

  // const closeForm = () => {
  //   onCancel();
  // };

  const handleConfirmCancel = () => {
    setStakeholderContactID("");
    setContactName("");
    setSalutationTypeId("");
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setEmailId([]);
    setPhoneNumber([]);
    setFaxNumber([]);
    setContactUserId("");
    setComment("");
    setIsActive(true);
    setIsAllowScheduling(false);
    setShowForm(false);
    setShowModal(false);
    setstakeholderContactDetailKey("0");
    setcommunicationDetailSubKey("0");
    setCredentialDetailSubKey("0");
    setSelectedContact(null);
    // Close modal after confirmation
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close modal without resetting form
  };

  const isSpecialStakeholder =
    StakeholderLabel === STAKEHOLDER_TYPE.QME_Doctor ||
    selectedUserRoleLabel === WEB_ROLE.QME_Doctor ||
    selectedUserRoleLabel === WEB_ROLE.IndependentQMEDoctor;

  const saluationLabel = salutationOptions.find(
    (role) => role.value === salutationTypeId
  )?.label;

  const handleEdit = (contact: any) => {
    setFullName("");
    setstakeholderContactDetailKey(null);
    setSelectedContact(contact);
    setShowForm(true);

    // Update userOptions immediately
    setUserOptions((prevUserOptions) => {
      const isUserAlreadyInList = prevUserOptions.some(
        (option) => option.value === contact.contactuserid
      );

      if (!isUserAlreadyInList) {
        return [
          ...prevUserOptions,
          { value: contact.contactuserid, label: contact.contactusernameEdit },
        ];
      }

      return prevUserOptions;
    });

    // Set state values instead of using formik.setValues
    setStakeholderContactID(contact.stakeholdercontactid || "");
    setContactName(contact.contactfullname || "");
    setSalutationTypeId(contact.salutationtypeid || "");
    setFirstName(contact.firstname || "");
    setMiddleName(contact.middlename || "");
    setLastName(contact.lastname || "");
    setSpecalization(contact.specialization || "");
    setExperience(contact.experienceinyears || "");
    setIsAllowScheduling(contact.isAllowScheduling === "Yes");

    setEmailId(
      contact.emailaddress
        ? contact.emailaddress.split(",").map((num: string) => num.trim())
        : []
    );
    setPhoneNumber(
      contact.phonenumber
        ? contact.phonenumber.split(",").map((num: string) => num.trim())
        : []
    );
    setFaxNumber(
      contact.faxnumber
        ? contact.faxnumber.split(",").map((num: string) => num.trim())
        : []
    );
    setContactUserId(contact.contactuserid || "");
    setComment(contact.comments || "");
    setIsActive(contact.isactive === 1);
  };

  const validateContactForm = () => {
    // Prepare values to pass for validation
    const validationErrors = validateStakeholderContactInfo(
      userRole,
      salutationTypeId,
      firstName,
      emailId,
      phoneNumber,
      faxNumber,
      isSpecialStakeholder, // Pass the flag

      specalization, // Pass specialization
      experience, // Pass experience
      StakeholderLabel,
      selectedUserRoleLabel
    );

    // Call the validation function

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n")); // Show error messages directly
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    if (isSaving) return;
    if (validateContactForm()) {
      try {
        setIsSaving(true);
        const payloadAdd = {
          stakeholderId: partyID,
          salutationTypeId: salutationTypeId,
          firstName: firstName.trim(),
          middleName: middleName.trim(),
          lastName: lastName.trim(),
          specialization: specalization ? specalization : "",
          //experienceinyears: experience ? experience : "",
          isAllowScheduling: isAllowScheduling ? 1 : 0,
          emailAddress: emailId.length > 0 ? emailId.join(",") : "",
          phoneNumber: phoneNumber.length > 0 ? phoneNumber.join(",") : "",
          faxNumber: faxNumber.length > 0 ? faxNumber.join(",") : "",
          contactUserId: contactUserId ? contactUserId : null,
          defaultWebRoleId: userRole ? userRole : 0,
          comments: comment,
          Isactive: isActive ? 1 : 0,
          createdBy: loggedInUserid,
        };

        const payloadUpdate = {
          stakeholderId: partyID,
          stakeholderContactId: stakeholderContactID,
          salutationTypeId: salutationTypeId,
          firstName: firstName.trim(),
          middleName: middleName.trim(),
          lastName: lastName.trim(),
          specialization: specalization ? specalization : "",
          //  experienceinyears: experience ? experience : "",
          isAllowScheduling: isAllowScheduling ? 1 : 0,
          emailAddress: emailId.length > 0 ? emailId.join(",") : "",
          phoneNumber: phoneNumber.length > 0 ? phoneNumber.join(",") : "",
          faxNumber: faxNumber.length > 0 ? faxNumber.join(",") : "",
          contactUserId: contactUserId ? contactUserId : null,
          defaultWebRoleId: userRole ? userRole : 0,
          comments: comment,
          Isactive: isActive ? 1 : 0,
          createdBy: loggedInUserid,
        };

        const isUpdate =
          selectedContact?.stakeholdercontactid || stakeholderContactID
            ? true
            : false;
        const apiMethod = isUpdate
          ? updateStakeholderContact
          : addStakeholderContact;

        const response = await apiMethod(isUpdate ? payloadUpdate : payloadAdd);

        const successMessage = isUpdate
          ? "Contact updated successfully."
          : "Contact created successfully.";

        if (response.isSuccess) {
          const selectedSalutation = salutationOptions.find(
            (option) => option.value === salutationTypeId
          );
          const salutationLabel = selectedSalutation
            ? selectedSalutation.label
            : "";

          // Construct full name
          const formattedFullName =
            `${salutationLabel} ${firstName.trim()} ${middleName.trim()} ${lastName.trim()}`.trim();

          // Update state
          setFullName(formattedFullName);

          setSnackbarMessage(successMessage);
          setError("success");
          setSnackbarOpen(true);
          setStakeholderContactID(response.result);
          fetchData();
          setShowForm(false);
          setstakeholderContactDetailKey("0");
          setcommunicationDetailSubKey("0");
          setCredentialDetailSubKey("0");
          if (isSpecialStakeholder) {
            setShowForm(true);
            fetchData();
            fetchContactUserData();
            if (isSpecialStakeholder) {
              setShowForm(true);
              fetchData();
              fetchContactUserData();
              if (!isUpdate && response.result) {
                const result = await addPartyNotificationConfiguration(
                  response.result
                );
              }
            }
          }
          if (!isSpecialStakeholder) {
            setShowForm(false);
            fetchData();
            fetchContactUserData();
            setstakeholderContactDetailKey("0");
          }
        } else {
          setSnackbarMessage("Failed to add or update contact");
          setError("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        setSnackbarMessage(
          "An error occurred while saving contact details. Please try again."
        );
        setError("error");
        setSnackbarOpen(true);
        console.error("Error during API call:", error);
      } finally {
        setIsSaving(false);
      }
    }
  };

  const stakeholderContactDetailAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={stakeholderContactDetailKey}
      onSelect={(key) => setstakeholderContactDetailKey(key as string)}
    />
  );

  const stakeholderContactDetailFormAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={stakeholderContactDetailFormKey}
      onSelect={(key) => setstakeholderContactDetailFormKey(key as string)}
    />
  );

  const [contactDetailSubKey, setContactDetailSubKey] = useState<string | null>(
    "0"
  );

  const contactDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={contactDetailSubKey}
      onSelect={(key) => setContactDetailSubKey(key as string)}
    />
  );
  const [communicationDetailSubKey, setcommunicationDetailSubKey] = useState<
    string | null
  >("0");

  const communicationDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={communicationDetailSubKey}
      onSelect={(key) => setcommunicationDetailSubKey(key as string)}
    />
  );
  const [credentialDetailSubKey, setCredentialDetailSubKey] = useState<
    string | null
  >(null);

  const credentialnDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={credentialDetailSubKey}
      onSelect={(key) => setCredentialDetailSubKey(key as string)}
    />
  );

  const clearUserFields = () => {
    if (!isSpecialStakeholder) {
      setSalutationTypeId("");
    }
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setEmailId([]);
    setPhoneNumber([]);
    setFaxNumber([]);
    setContactUserId(""); // Also reset contact user if needed
  };

  return (
    <>
      {" "}
      {(activeTab === "contact" || !isSpecialStakeholder) && showForm && (
        <>
          {stakeholderContactDetailFormAccordion([
            {
              title: "Contact Details",
              content: (
                <>
                  <Row className="align-items-center mb-3">
                    {StakeholderLabel === STAKEHOLDER_TYPE.PMC && (
                      <Col sm={3} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="User Role"
                          value={userRole}
                          options={userRoleOption}
                          onChange={(e) => {
                            setUserRole(e.target.value);
                            clearUserFields(); // Reset all fields
                          }}
                          name="userRole"
                          required={true}
                        />
                      </Col>
                    )}

                    <Col sm={6} md={4}>
                      <div className="d-flex align-items-center toggle-btn">
                        <span className="me-3 fw-semibold">
                          Is User Already Created
                        </span>
                        <span className="me-2">No</span>
                        <Form.Check
                          type="switch"
                          id="sort-switch"
                          checked={isAlreadyUser}
                          disabled
                        />
                        <span className="ms-2">Yes</span>
                      </div>
                    </Col>
                  </Row>
                  {credentialnDetailSubAccordion([
                    {
                      title: "Credential Details",
                      content: (
                        <>
                          <Row>
                            <Col sm={3} className="selection_dropdown">
                              <SearchableSingleSelectDropdown
                                label="Contact User"
                                value={contactUserId}
                                options={userOptions}
                                onChange={(e) =>
                                  setContactUserId(e.target.value)
                                }
                                name="ContactUserId"
                              />
                            </Col>
                            <Col sm={12} className="mt-3">
                              <MultilineTextBox
                                label="Comment"
                                name="comments"
                                value={comment}
                                onChange={(e) => {
                                  const trimmedValue =
                                    e.target.value.trimStart();
                                  setComment(trimmedValue || "");
                                }}
                                maxLength={1000}
                              />
                            </Col>
                          </Row>
                          <Row className="mt-2">
                            <div className="col-md-3">
                              <div className="form-check p-2 py-2">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="Isactive"
                                  name="Isactive"
                                  checked={isActive}
                                  onChange={(e) =>
                                    setIsActive(e.target.checked)
                                  }
                                  style={{ cursor: "pointer" }}
                                  disabled={
                                    !selectedContact?.stakeholdercontactid
                                  }
                                />
                                <label className="form-check-label">
                                  Is Active?{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                              </div>
                            </div>
                          </Row>
                        </>
                      ),
                    },
                  ])}

                  {contactDetailSubAccordion([
                    {
                      title: "Details",
                      content: (
                        <>
                          <Row className="mt-1">
                            <Col sm={3} className="selection_dropdown">
                              <SearchableSingleSelectDropdown
                                label="Salutation"
                                value={salutationTypeId}
                                options={salutationOptions}
                                onChange={(e) =>
                                  setSalutationTypeId(e.target.value)
                                }
                                name="Salutationtypeid"
                                required={true}
                                disabled={
                                  !!contactUserId || isSpecialStakeholder
                                }
                              />
                            </Col>
                            <Col sm={3}>
                              <TextInput
                                label="First Name"
                                name="Firstname"
                                value={firstName}
                                onChange={(e) => {
                                  const onlyText = e.target.value.replace(
                                    /[^a-zA-Z]/g,
                                    ""
                                  );
                                  setFirstName(onlyText);
                                }}
                                spacesTrim={true}
                                required={true}
                                maxLength={30}
                                disabled={!!contactUserId}
                              />
                            </Col>
                            <Col sm={3}>
                              <TextInput
                                label="Middle Name"
                                name="Middlename"
                                value={middleName}
                                onChange={(e) => {
                                  const onlyText = e.target.value.replace(
                                    /[^a-zA-Z]/g,
                                    ""
                                  );
                                  setMiddleName(onlyText);
                                }}
                                spacesTrim={true}
                                maxLength={20}
                                disabled={!!contactUserId}
                              />
                            </Col>
                            <Col sm={3}>
                              <TextInput
                                label="Last Name"
                                name="Lastname"
                                value={lastName}
                                onChange={(e) => {
                                  const onlyText = e.target.value.replace(
                                    /[^a-zA-Z]/g,
                                    ""
                                  );
                                  setLastName(onlyText);
                                }}
                                spacesTrim={true}
                                maxLength={30}
                                disabled={!!contactUserId}
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            {isSpecialStakeholder && (
                              <Row className="mt-3 align-items-end d-flex align-items-center">
                                <Col sm={6}>
                                  <TextInput
                                    label="Specialization"
                                    name="specialization"
                                    value={specalization}
                                    onChange={(e) =>
                                      setSpecalization(e.target.value)
                                    }
                                    maxLength={200}
                                    required={true}
                                  />
                                </Col>
                                {/* <Col sm={3}>
                                  <TextInput
                                    label="Experience"
                                    name="experience"
                                    value={experience}
                                    onChange={(e) => {
                                      const numericValue =
                                        e.target.value.replace(/\D/g, "");
                                      setExperience(numericValue);
                                    }}
                                    maxLength={3}
                                    required={true}
                                  />
                                </Col> */}
                                <Col sm={6} className=" mt-3">
                                  <div className="form-check ps-2 d-flex align-items-center">
                                    <label
                                      className="form-check-label mb-0 me-3"
                                      htmlFor="Isactive"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      Allow Scheduling ?
                                    </label>
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="Isactive"
                                      name="Isactive"
                                      checked={isAllowScheduling}
                                      onChange={(e) =>
                                        setIsAllowScheduling(e.target.checked)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        marginRight: "6px",
                                      }}
                                    />
                                    <span style={{ minWidth: "30px" }}>
                                      {isAllowScheduling ? "Yes" : "No"}
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </Row>
                        </>
                      ),
                    },
                  ])}

                  {communicationDetailSubAccordion([
                    {
                      title: "Communication Details",
                      content: (
                        <>
                          <Row>
                            <Col sm={4}>
                              <TagComponent
                                label="Email Address"
                                value={emailId}
                                onChange={setEmailId}
                                required={true}
                              />
                            </Col>
                            <Col sm={4}>
                              <TagComponent
                                label="Phone Number"
                                value={phoneNumber}
                                onChange={(newValues) =>
                                  setPhoneNumber(newValues.map(String))
                                }
                                isPhoneOrFax={true}
                              />
                            </Col>
                            <Col sm={4}>
                              <TagComponent
                                label="Fax No"
                                value={faxNumber}
                                onChange={(newValues) =>
                                  setFaxNumber(newValues.map(String))
                                }
                                isPhoneOrFax={true}
                              />
                            </Col>
                          </Row>
                        </>
                      ),
                    },
                  ])}

                  <Row className="mt-3 mb-3">
                    <Col sm={12} className="d-flex justify-content-end">
                      <Button
                        variant="outline-info"
                        className="d-flex align-items-center"
                        onClick={handleCancel}
                      >
                        <span className="material-icons mr-2">close</span>Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="primary"
                        className="ms-3 d-flex align-items-center"
                        onClick={handleSave}
                        disabled={isSaving}
                      >
                        <span className="material-icons mx-1">save</span>Save
                      </Button>
                    </Col>
                  </Row>

                  {isSpecialStakeholder && stakeholderContactID && (
                    <AddNewContactLocation
                      stakeholdercontactid={stakeholderContactID}
                      contactName={fullName ? fullName : contactName}
                      activeTab={activeTab}
                      onBack={onBack}
                    />
                  )}

                  <OverlayDrawer
                    title={"Logs"}
                    open={showDrawer}
                    onClose={handleCloseDrawer}
                    placement="bottom"
                  >
                    <DataTable
                      headers={CONTACT_LOG_HEADERS}
                      rows={contactDetails}
                      isLogTable={true}
                    />
                  </OverlayDrawer>
                </>
              ),
            },
          ])}
        </>
      )}
      <Modal show={showModal} onHide={handleCloseModal}>
        {/* <Modal.Header closeButton>
                <Modal.Title>Confirm Cancellation</Modal.Title>
              </Modal.Header> */}
        <Modal.Body className="fw-bold text-left modelheading">
          <div>Are you sure you want to cancel the form?</div>
          <div style={{ fontWeight: "300" }}>
            {" "}
            Any unsaved data will be lost.
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end bg-light ">
          <Button
            variant="outline-info"
            className="d-flex align-items-center"
            onClick={handleCloseModal}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={handleConfirmCancel}
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <>
        {/* Condition 1: For non-special stakeholders, only if form is not visible */}
        {!isSpecialStakeholder &&
          StakeholderLabel != STAKEHOLDER_TYPE.PMC &&
          !showForm && (
            <>
              {stakeholderContactDetailAccordion([
                {
                  title: "Contact List",
                  content: (
                    <>
                      <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment col mb-3">
                        <h3 className="mr-2 me-auto">List</h3>
                        <div className="address_cta_pos_relative mt-1">
                          <div className="container-fluid">
                            <div className="hstack gap-2">
                              <Button
                                className="btn btn-primary d-flex align-items-center"
                                onClick={handleAddContact}
                                style={{ float: "right" }}
                              >
                                <span className="material-icons me-2">add</span>
                                Add
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      {showPreviousContacts && (
                        <DataTable
                          headers={STAKEHOLDERS_CONTACT}
                          rows={contactData}
                          onAction={(contact) => handleEdit(contact)}
                        />
                      )}
                    </>
                  ),
                },
              ])}
              {/* <Row>
                <Col md={6} className="d-flex justify-content-start">
                  <Button
                    variant="outline"
                    className="btn d-flex align-items-center btn-text-border"
                    onClick={onBack}
                  >
                    <span className="material-icons me-1">arrow_back</span>
                    Back
                  </Button>
                </Col>
              </Row> */}
            </>
          )}

        {/* Condition 2: For special stakeholders, regardless of showForm */}
        {(isSpecialStakeholder || StakeholderLabel == STAKEHOLDER_TYPE.PMC) &&
          activeTab === "contact" &&
          !showForm && (
            <>
              {stakeholderContactDetailAccordion([
                {
                  title: "Contact List",
                  content: (
                    <>
                      <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment col mb-3">
                        <h3 className="mr-2 me-auto">List</h3>
                        <div className="address_cta_pos_relative mt-1">
                          <div className="container-fluid">
                            <div className="hstack gap-2">
                              <Button
                                className="btn btn-primary d-flex align-items-center float-end"
                                onClick={handleAddContact}
                              >
                                <span className="material-icons mx-1">add</span>
                                Add
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>

                      {(isSpecialStakeholder ||
                        StakeholderLabel == STAKEHOLDER_TYPE.PMC) &&
                        showPreviousContacts && (
                          <DataTable
                            headers={STAKEHOLDERS_QME_CONTACT}
                            rows={contactData}
                            onAction={(contact) => handleEdit(contact)}
                          />
                        )}
                    </>
                  ),
                },
              ])}
            </>
          )}
      </>
      <Col sm={6} className="d-flex justify-content-start">
        {showForm && (selectedContact?.stakeholdercontactid || stakeholderContactID) ? (
          <OverlayTrigger
            show={showTooltip}
            placement="auto"
            trigger={["hover", "focus"]} // Important to prevent sticky tooltip
            delay={{ show: 200, hide: 100 }}
            overlay={
              <Tooltip style={{ backgroundColor: "#b3e0ff" }}>Logs</Tooltip>
            }
          >
            <div className="d-flex">
              <Button
                type="button"
                className="btn btn-primary d-flex align-items-center mx-2"
                onClick={handlePDFClick}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <span className="material-icons">description</span>
              </Button>
            </div>
          </OverlayTrigger>
        ) : null}

        {showForm ? (
          <button
            className="btn d-flex align-items-center btn-text-border me-2"
            onClick={handleConfirmCancel}
          >
            <span className="material-icons">arrow_back</span>Back
          </button>
        ) : (
          <button
            className="btn d-flex align-items-center btn-text-border me-2"
            onClick={onBack}
          >
            <span className="material-icons">arrow_back</span>Back
          </button>
        )}
      </Col>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
    </>
  );
};

export default AddNewPartyContact;
